<template>
  <v-container class="pa-4">
    <v-row justify="center" class="button-row">
      <v-col cols="auto" class="text-center">
        <v-btn
          class="button-custom"
          elevation="6"
          fab
          color="cyan"
          @click="abrirModalDescargaPruebas"
        >
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">Contratos</div>
      </v-col>
      <v-col cols="auto" class="text-center">
        <v-btn
          class="button-custom"
          elevation="6"
          fab
          color="cyan"
          @click="abrirModalCCliente"
        >
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">Clientes Varios</div>
      </v-col>
    </v-row>
    <v-row justify="center" class="button-row">
      <v-col cols="auto" class="text-center">
        <v-btn
          class="button-custom"
          elevation="6"
          fab
          color="cyan"
          @click="abrirModalDescargaBien"
        >
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">Rendimiento por Bien</div>
      </v-col>
      <v-col cols="auto" class="text-center">
        <v-btn
          class="button-custom"
          elevation="6"
          fab
          color="cyan"
          @click="abrirModalDescargaContrato"
        >
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">Rendimiento por Contrato</div>
      </v-col>
    </v-row>
    <v-row justify="center" class="button-row">
      <v-col cols="auto" class="text-center">
        <v-btn
          class="button-custom"
          elevation="6"
          fab
          color="cyan"
          @click="abrirModalDescargaCliente"
        >
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">Rendimiento por Cliente</div>
      </v-col>
      <v-col cols="auto" class="text-center">
        <v-btn
          class="button-custom"
          elevation="6"
          fab
          color="cyan"
          @click="abrirModalDescargaIngresos"
        >
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">
          Reporte Rendimiento Ingresos
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" class="button-row">
      <v-col cols="auto" class="text-center">
        <v-btn
          class="button-custom"
          elevation="6"
          fab
          color="cyan"
          @click="abrirModalDescargaIngresosBancos"
        >
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">
          Reporte Rendimiento Ingresos Bancos
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" class="button-row">
      <v-col cols="auto" class="text-center">
        <v-btn
          class="button-custom"
          elevation="6"
          fab
          color="cyan"
          @click="abrirModalDescargaCXCsegmentado"
        >
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">
          CxC Segmentadas por Vencimiento
        </div>
      </v-col>
      <v-col cols="auto" class="text-center">
        <v-btn
          class="button-custom"
          elevation="6"
          fab
          color="cyan"
          @click="abrirModalFlujo"
        >
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">Flujo de Efectivo</div>
      </v-col>
      <v-col cols="auto" class="text-center">
        <v-btn
          class="button-custom"
          elevation="6"
          fab
          color="cyan"
          @click="abrirModalBienesExtinguidosCautelados"
        >
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">
          Bienes extinguidos y cautelado
        </div>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog_select_pruebas"
      persistent
      max-width="500px"
      class="dialog-custom"
    >
      <v-card>
        <v-card-title class="text-h6">
          Selecciona el tipo de archivo
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="folio"
            label="Agregar folio"
            hide-details
          ></v-checkbox>
        </v-card-title>

        <v-card-actions class="actions-custom">
          <v-row justify="center" class="mb-2">
            <v-card-actions class="actions-custom">
              <v-row justify="center" class="mb-2">
                <v-col cols="12">
                  <v-text-field
                    v-model="num_folio"
                    label="Num. folio"
                    outlined
                    dense
                    hide-details
                    class="pa-0"
                    v-if="folio"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="cliente"
                    :items="items_clientes_lista"
                    item-text="nombre"
                    item-value="codigo"
                    label="Cliente"
                    outlined
                    dense
                    hide-details
                    return-object
                  >
                    <template v-slot:selection="data">
                      {{ data.item.codigo }} {{ data.item.nombre }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.codigo }} {{ data.item.nombre }}
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="codigo_bien"
                    :items="items_contratos"
                    item-text="codigo_bien"
                    item-value="id_contrato_cliente"
                    label="Código del bien"
                    outlined
                    dense
                    hide-details
                    return-object
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="contrato"
                    :items="items_contratos"
                    item-text="numero_contrato"
                    item-value="id_contrato_cliente"
                    label="Número de Contrato"
                    outlined
                    dense
                    hide-details
                    return-object
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="auto">
                  <v-btn
                    color="cyan"
                    @click="descargarArchivoPruebas('pdf')"
                    class="btn-custom"
                    >PDF</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="green"
                    @click="descargarArchivoPruebas('xls')"
                    class="btn-custom"
                    >EXCEL</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="red"
                    @click="
                      (dialog_select_pruebas = false),
                        (folio = false),
                        (num_folio = '')
                    "
                    class="btn-custom-cancel"
                    >Cancelar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_select_CXC"
      persistent
      max-width="500px"
      class="dialog-custom"
    >
      <v-card>
        <v-card-title class="text-h6">
          Selecciona el tipo de archivo
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="folio"
            label="Agregar folio"
            hide-details
          ></v-checkbox>
        </v-card-title>

        <v-card-actions class="actions-custom">
          <v-row justify="center" class="mb-2">
            <v-card-actions class="actions-custom">
              <v-row justify="center" class="mb-2">
                <v-col cols="12">
                  <v-text-field
                    v-model="num_folio"
                    label="Num. folio"
                    outlined
                    dense
                    hide-details
                    class="pa-0"
                    v-if="folio"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-17">
                  <v-text-field
                    v-model="fecha_contrato"
                    label="Fecha Contrato"
                    outlined
                    dense
                    hide-details
                    type="date"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-17">
                  <v-text-field
                    v-model="fecha_vencimiento"
                    label="Fecha Vencimiento"
                    outlined
                    dense
                    hide-details
                    type="date"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="cyan"
                    @click="descargarArchivoCXC('pdf')"
                    class="btn-custom"
                    >PDF</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="green"
                    @click="descargarArchivoCXC('xls')"
                    class="btn-custom"
                    >EXCEL</v-btn
                  >
                </v-col>

                <v-col cols="auto">
                  <v-btn
                    color="red"
                    @click="
                      (dialog_select_CXC = false),
                        (folio = false),
                        (num_folio = '')
                    "
                    class="btn-custom-cancel"
                    >Cancelar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_select_rendimiento_bien"
      persistent
      max-width="500px"
      class="dialog-custom"
    >
      <v-card>
        <v-card-title class="text-h6">
          Selecciona el tipo de archivo
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="folio"
            label="Agregar folio"
            hide-details
          ></v-checkbox>
        </v-card-title>

        <v-card-actions class="actions-custom">
          <v-row justify="center" class="mb-2">
            <v-card-actions class="actions-custom">
              <v-row justify="center" class="mb-2">
                <v-col cols="12">
                  <v-text-field
                    v-model="num_folio"
                    label="Num. folio"
                    outlined
                    dense
                    hide-details
                    class="pa-0"
                    v-if="folio"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="codigo_bien"
                    :items="items_contratostodos"
                    item-text="codigo_bien"
                    item-value="id_contrato_cliente"
                    label="Código del bien"
                    outlined
                    dense
                    hide-details
                    return-object
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="cyan"
                    @click="descargarArchivoBien('pdf')"
                    class="btn-custom"
                    >PDF</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="green"
                    @click="descargarArchivoBien('xls')"
                    class="btn-custom"
                    >EXCEL</v-btn
                  >
                </v-col>

                <v-col cols="auto">
                  <v-btn
                    color="red"
                    @click="
                      (dialog_select_rendimiento_bien = false),
                        (folio = false),
                        (num_folio = '')
                    "
                    class="btn-custom-cancel"
                    >Cancelar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_select_rendimiento_contrato"
      persistent
      max-width="500px"
      class="dialog-custom"
    >
      <v-card>
        <v-card-title class="text-h6">
          Selecciona el tipo de archivo
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="folio"
            label="Agregar folio"
            hide-details
          ></v-checkbox>
        </v-card-title>

        <v-card-actions class="actions-custom">
          <v-row justify="center" class="mb-2">
            <v-card-actions class="actions-custom">
              <v-row justify="center" class="mb-2">
                <v-col cols="12">
                  <v-text-field
                    v-model="num_folio"
                    label="Num. folio"
                    outlined
                    dense
                    hide-details
                    class="pa-0"
                    v-if="folio"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="contrato"
                    :items="items_contratostodos"
                    item-text="numero_contrato"
                    item-value="id_contrato_cliente"
                    label="Contrato"
                    outlined
                    dense
                    hide-details
                    return-object
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="cyan"
                    @click="descargarArchivoContrato('pdf')"
                    class="btn-custom"
                    >PDF</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="green"
                    @click="descargarArchivoContrato('xls')"
                    class="btn-custom"
                    >EXCEL</v-btn
                  >
                </v-col>

                <v-col cols="auto">
                  <v-btn
                    color="red"
                    @click="
                      (dialog_select_rendimiento_contrato = false),
                        (folio = false),
                        (num_folio = '')
                    "
                    class="btn-custom-cancel"
                    >Cancelar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_select_rendimiento_cliente"
      persistent
      max-width="500px"
      class="dialog-custom"
    >
      <v-card>
        <v-card-title class="text-h6">
          Selecciona el tipo de archivo
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="folio"
            label="Agregar folio"
            hide-details
          ></v-checkbox>
        </v-card-title>

        <v-card-actions class="actions-custom">
          <v-row justify="center" class="mb-2">
            <v-card-actions class="actions-custom">
              <v-row justify="center" class="mb-2">
                <v-col cols="12">
                  <v-text-field
                    v-model="num_folio"
                    label="Num. folio"
                    outlined
                    dense
                    hide-details
                    class="pa-0"
                    v-if="folio"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="cliente"
                    :items="items_clientes_lista"
                    item-text="nombre"
                    item-value="codigo"
                    label="Cliente"
                    outlined
                    dense
                    hide-details
                    return-object
                  >
                    <template v-slot:selection="data">
                      {{ data.item.codigo }} {{ data.item.nombre }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.codigo }} {{ data.item.nombre }}
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="cyan"
                    @click="descargarArchivoClienteIngreso('pdf')"
                    class="btn-custom"
                    >PDF</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="green"
                    @click="descargarArchivoClienteIngreso('xls')"
                    class="btn-custom"
                    >EXCEL</v-btn
                  >
                </v-col>

                <v-col cols="auto">
                  <v-btn
                    color="red"
                    @click="
                      (dialog_select_rendimiento_cliente = false),
                        (folio = false),
                        (num_folio = '')
                    "
                    class="btn-custom-cancel"
                    >Cancelar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_select_rendimiento_ingresos"
      persistent
      fullscreen
      scrollable
    >
      <v-card>
        <v-card-title class="text-h6">
          Selecciona el tipo de archivo
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="folio"
            label="Agregar folio"
            hide-details
          ></v-checkbox>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="auto">
              <v-autocomplete
                v-model="fecha_rendimiento_ingresos"
                :items="items_meses_rendimiento_ingresos"
                item-text="text"
                item-value="value"
                label="MES"
                outlined
                dense
                hide-details
                @input="listarRendimientoIngresos()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="num_folio"
                label="Num. folio"
                outlined
                dense
                hide-details
                class="pa-0"
                v-if="folio"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers_rendimiento_ingresos"
                :items="items_rendimiento_ingresos"
                dense
                :loading="loading_rendimiento_ingresos"
              ></v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="cyan"
            @click="descargarArchivoIngresos('pdf')"
            class="btn-custom"
            v-if="false"
            >PDF</v-btn
          >
          <v-btn
            color="green"
            @click="descargarArchivoIngresos('xls')"
            class="btn-custom"
            >EXCEL</v-btn
          >
          <v-btn
            color="red"
            @click="
              (dialog_select_rendimiento_ingresos = false),
                (folio = false),
                (num_folio = '')
            "
            class="btn-custom-cancel"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_select_rendimiento_ingresos_bancos"
      persistent
      max-width="500px"
      class="dialog-custom"
    >
      <v-card>
        <v-card-title class="text-h6">
          Selecciona el tipo de archivo
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="folio"
            label="Agregar folio"
            hide-details
          ></v-checkbox>
        </v-card-title>

        <v-card-actions class="actions-custom">
          <v-row justify="center" class="mb-2">
            <v-card-actions class="actions-custom">
              <v-row justify="center" class="mb-2">
                <v-col cols="12">
                  <v-text-field
                    v-model="num_folio"
                    label="Num. folio"
                    outlined
                    dense
                    hide-details
                    class="pa-0"
                    v-if="folio"
                  ></v-text-field>
                </v-col>

                <v-col cols="6" class="d-flex justify-center">
                  <v-checkbox
                    v-model="fecha_factura"
                    label="Fecha Factura"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="6" class="d-flex justify-center">
                  <v-checkbox
                    v-model="fecha_abono"
                    label="Fecha Abono"
                    hide-details
                  ></v-checkbox>
                </v-col>

                <v-col cols="6" class="pa-17">
                  <v-text-field
                    v-model="fecha_desde"
                    label="Desde"
                    outlined
                    dense
                    hide-details
                    type="date"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-17">
                  <v-text-field
                    v-model="fecha_hasta"
                    label="Hasta"
                    outlined
                    dense
                    hide-details
                    type="date"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="cyan"
                    @click="descargarArchivoIngresosBancos('pdf')"
                    class="btn-custom"
                    >PDF</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="green"
                    @click="descargarArchivoIngresosBancos('xls')"
                    class="btn-custom"
                    >EXCEL</v-btn
                  >
                </v-col>

                <v-col cols="auto">
                  <v-btn
                    color="red"
                    @click="
                      (dialog_select_rendimiento_ingresos_bancos = false),
                        (folio = false),
                        (num_folio = '')
                    "
                    class="btn-custom-cancel"
                    >Cancelar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_select_flujo"
      persistent
      max-width="500px"
      class="dialog-custom"
    >
      <v-card>
        <v-card-title class="text-h6">
          Selecciona el tipo de archivo
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="folio"
            label="Agregar folio"
            hide-details
          ></v-checkbox>
        </v-card-title>

        <v-card-actions class="actions-custom">
          <v-row justify="center" class="mb-2">
            <v-card-actions class="actions-custom">
              <v-row justify="center" class="mb-2">
                <v-col cols="12">
                  <v-text-field
                    v-model="num_folio"
                    label="Num. folio"
                    outlined
                    dense
                    hide-details
                    class="pa-0"
                    v-if="folio"
                  ></v-text-field>
                </v-col>
                <v-col class="pa-17">
                  <v-text-field
                    v-model="anio"
                    label="anio"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="cyan"
                    @click="descargarArchivoFlujo('pdf')"
                    class="btn-custom"
                    >PDF</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="green"
                    @click="descargarArchivoFlujo('xls')"
                    class="btn-custom"
                    >EXCEL</v-btn
                  >
                </v-col>

                <v-col cols="auto">
                  <v-btn
                    color="red"
                    @click="
                      (dialog_select_flujo = false),
                        (folio = false),
                        (num_folio = '')
                    "
                    class="btn-custom-cancel"
                    >Cancelar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_select_bienes_extiguido_cautelado"
      persistent
      max-width="500px"
      class="dialog-custom"
    >
      <v-card>
        <v-card-title class="text-h6">
          Selecciona el tipo de archivo
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="folio"
            label="Agregar folio"
            hide-details
          ></v-checkbox>
        </v-card-title>

        <v-card-actions class="actions-custom">
          <v-row justify="center" class="mb-2">
            <v-card-actions class="actions-custom">
              <v-row justify="center" class="mb-2">
                <v-col cols="12">
                  <v-text-field
                    v-model="num_folio"
                    label="Num. folio"
                    outlined
                    dense
                    hide-details
                    class="pa-0"
                    v-if="folio"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-17">
                  <v-autocomplete
                    v-model="mes"
                    :items="items_mes"
                    label="Mes"
                    item-text="mes"
                    item-value="id_mes"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" class="pa-17">
                  <v-text-field
                    v-model="anio"
                    label="Año"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="cyan"
                    @click="descargarArchivoBienesExtiguidosCautelados('pdf')"
                    class="btn-custom"
                    >PDF</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="green"
                    @click="descargarArchivoBienesExtiguidosCautelados('xls')"
                    class="btn-custom"
                    >EXCEL</v-btn
                  >
                </v-col>

                <v-col cols="auto">
                  <v-btn
                    color="red"
                    @click="
                      (dialog_select_bienes_extiguido_cautelado = false),
                        (folio = false),
                        (num_folio = '')
                    "
                    class="btn-custom-cancel"
                    >Cancelar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_select_cliente"
      persistent
      max-width="500px"
      class="dialog-custom"
    >
      <v-card>
        <v-card-title class="text-h6">
          Selecciona el tipo de archivo
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="folio"
            label="Agregar folio"
            hide-details
          ></v-checkbox>
        </v-card-title>

        <v-card-actions class="actions-custom">
          <v-row justify="center" class="mb-2">
            <v-card-actions class="actions-custom">
              <v-row justify="center" class="mb-2">
                <v-col cols="12">
                  <v-text-field
                    v-model="num_folio"
                    label="Num. folio"
                    outlined
                    dense
                    hide-details
                    class="pa-0"
                    v-if="folio"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-17">
                  <v-autocomplete
                    v-model="mes"
                    :items="items_mes"
                    label="Mes"
                    item-text="mes"
                    item-value="id_mes"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" class="pa-17">
                  <v-text-field
                    v-model="anio"
                    label="Año"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="cyan"
                    @click="descargarArchivoCliente('pdf')"
                    class="btn-custom"
                    >PDF</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="green"
                    @click="descargarArchivoCliente('xls')"
                    class="btn-custom"
                    >EXCEL</v-btn
                  >
                </v-col>

                <v-col cols="auto">
                  <v-btn
                    color="red"
                    @click="
                      (dialog_select_cliente = false),
                        (folio = false),
                        (num_folio = '')
                    "
                    class="btn-custom-cancel"
                    >Cancelar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_preview_report" fullscreen persistent>
      <v-toolbar flat dense>
        <v-toolbar-title>Documento</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="dialog_preview_report = false"
          >far fa-times-circle</v-icon
        >
      </v-toolbar>
      <iframe :src="base64_doc" id="myPDF" frameborder="0"></iframe>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      timeout="4000"
      color="blue"
      multi-line
      elevation="4"
      outlined
      top
      right
    >
      <v-icon>fa-solid fa-circle-info</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
var XLSX = require("xlsx");

export default {
  name: "CircularButtons",
  data() {
    return {
      items: [],
      anio: "2026",
      fecha_filtro: "",
      mes: "",
      sucursal: "",

      //Requsitos
      tipoDocumento: "", // A
      documento_identificador: "", // B
      nombre: "", // C
      fecha: "", // D
      serie: "", // E
      documento: "", // F
      internas_importaciones: "", // G
      iva: "", // H
      tipo_operacion: "", // I
      clasificacion: "", // J
      rubro: "", // K
      costo_gastos: "", // L
      numeroAnexo: "5", // M

      dialog_preview_report: false,
      base64_doc: "",

      loading_compras: false,
      items_compras: [],
      items_sucursales: [],
      items_mes: [],
      items_fac: [],
      items_clientes: [],
      cliente: null,
      items_clientes_lista: [],
      items_contratos: [],
      codigo_bien: null,
      contrato: null,
      items_contratostodos: [],
      fecha_desde: "",
      fecha_hasta: "",
      fecha_contrato: "",
      fecha_vencimiento: "",
      fecha_factura: "",
      fecha_abono: "",

      snackbar: false,
      snackbar_text: "",

      dialog_select_pruebas: false,
      dialog_select_rendimiento_bien: false,
      dialog_select_rendimiento_contrato: false,
      dialog_select_rendimiento_ingresos: false,
      dialog_select_rendimiento_ingresos_bancos: false,
      dialog_select_rendimiento_cliente: false,
      dialog_select_CXC: false,
      dialog_select_flujo: false,
      dialog_select_bienes_extiguido_cautelado: false,
      dialog_select_cliente: false,
      folio: false,
      num_folio: "",
      headers_rendimiento_ingresos: [
        { text: "Fecha", value: "Fecha" },
        { text: "No. Documento", value: "Numero control", align: "center" },
        { text: "Tipo documento", value: "Tipo documento" },
        { text: "Arrendatario", value: "Arrendatario" },
        { text: "Desglose", value: "Desglose" },
        { text: "Arrendamiento", value: "Arrendamiento" },
        { text: "Deposito", value: "Deposito" },
        { text: "Gastos Admon", value: "Gasto admon" },
        { text: "Venta directa", value: "Venta directa" },
        { text: "Subasta", value: "Subasta" },
        { text: "Subasta incautados", value: "Subasta incautada" },
        { text: "Bases para subasta", value: "Bases subastas" },
      ],
      items_rendimiento_ingresos: [],
      fecha_rendimiento_ingresos: (new Date().getMonth() + 1).toString(),
      items_meses_rendimiento_ingresos: [
        { text: "ENERO", value: "1" },
        { text: "FEBRERO", value: "2" },
        { text: "MARZO", value: "3" },
        { text: "ABRIL", value: "4" },
        { text: "MAYO", value: "5" },
        { text: "JUNIO", value: "6" },
        { text: "JULIO", value: "7" },
        { text: "AGOSTO", value: "8" },
        { text: "SEPTIEMBRE", value: "9" },
        { text: "OCTUBRE", value: "10" },
        { text: "NOVIEMBRE", value: "11" },
        { text: "DICIEMBRE", value: "12" },
      ],
      loading_rendimiento_ingresos: false
    };
  },

  created() {
    this.listarSucursales();
    this.listarMes();
    this.listarProveedores();
    this.listarClientes();
    this.listarContratoCliente();
    this.generarReporte();
    this.listarContratoClienteTodos();
  },

  watch: {
    cliente(nuevoCliente) {
      this.items_contratos = [];
      this.codigo_bien = null;
      this.contrato = null;

      if (nuevoCliente && nuevoCliente.id_cliente) {
        this.listarContratoCliente(nuevoCliente.id_cliente);
      }
    },
  },

  methods: {
    abrirModalDescargaPruebas() {
      this.dialog_select_pruebas = true;
    },
    abrirModalDescargaBien() {
      this.dialog_select_rendimiento_bien = true;
    },
    abrirModalDescargaContrato() {
      this.dialog_select_rendimiento_contrato = true;
    },
    abrirModalDescargaCliente() {
      this.dialog_select_rendimiento_cliente = true;
    },
    abrirModalDescargaIngresos() {
      this.listarRendimientoIngresos();
      this.dialog_select_rendimiento_ingresos = true;
    },
    abrirModalDescargaIngresosBancos() {
      this.dialog_select_rendimiento_ingresos_bancos = true;
    },
    abrirModalFlujo() {
      this.dialog_select_flujo = true;
    },
    abrirModalBienesExtinguidosCautelados() {
      this.dialog_select_bienes_extiguido_cautelado = true;
    },
    abrirModalCCliente() {
      this.dialog_select_cliente = true;
    },
    abrirModalDescargaCXCsegmentado() {
      this.dialog_select_CXC = true;
    },
    descargarArchivoPruebas(tipo) {
      if (tipo === "pdf" || tipo === "xls") {
        this.descargarPruebas(tipo);
      } else if (tipo === "csv") {
        this.obtenerDatosParaCSVCCF();
      }
      this.dialog_select_download = false;
    },

    descargarPruebas(tipo) {
      const idEmpresa = this.$store.state.emp.id_empresa;
      if (!idEmpresa) {
        console.error("El id_empresa es undefined");
        return;
      }

      this.loading_facturas = true;

      const parametros = {
        id_empresa: idEmpresa,
        tipo_doc: tipo, // "pdf" o "xls"
        server: "SERVER", // LOCAL o SERVER
        //folio: this.num_folio,
        id_cliente: this.cliente ? this.cliente.id_cliente : null,
        codigo_bien: this.codigo_bien ? this.codigo_bien.codigo_bien : null,
        numero_contrato: this.contrato ? this.contrato.numero_contrato : null,
      };

      axios
        .post("api/Clientes/Contratos", parametros)
        .then((response) => {
          if (tipo == "xls") {
            this.descargarArchivoExcel(
              this.generarBlob(response.data, "application/vnd.ms-excel"),
              "REPORTE_CONTRATOS.xls"
            );
          } else {
            this.base64_doc = "data:application/pdf;base64," + response.data;
            this.dialog_preview_report = true;
          }
        })
        .catch(() => {
          this.snackbar_text = "No se pudo generar el reporte de Contratos";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading_facturas = false;
        });
    },

    descargarArchivoBien(tipo) {
      if (tipo === "pdf" || tipo === "xls") {
        this.descargarBien(tipo);
      }
      this.dialog_select_rendimiento_bien = false;
    },

    descargarBien(tipo) {
      const idEmpresa = this.$store.state.emp.id_empresa;
      if (!idEmpresa) {
        console.error("El id_empresa es undefined");
        return;
      }

      this.loading_facturas = true;

      const parametros = {
        id_empresa: idEmpresa,
        tipo_doc: tipo,
        anio: this.anio,
        server: "SERVER",
        folio: this.num_folio,
        codigo_bien: this.codigo_bien ? this.codigo_bien.codigo_bien : null,
      };

      axios
        .post("api/Facturas/Ingreso", parametros)
        .then((response) => {
          if (tipo == "xls") {
            this.descargarArchivoExcel(
              this.generarBlob(response.data, "application/vnd.ms-excel"),
              "REPORTE_BIEN.xls"
            );
          } else {
            this.base64_doc = "data:application/pdf;base64," + response.data;
            this.dialog_preview_report = true;
          }
        })
        .catch((error) => {
          console.error("STATUS:", error?.response?.status);
          console.error("DATA:", error?.response?.data);
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading_facturas = false;
        });
    },

    listarContratoCliente(id_cliente) {
      axios.get("api/ContratoCliente/Listar/" + id_cliente).then((response) => {
        if (Array.isArray(response.data)) {
          this.items_contratos = response.data;
        } else {
          console.error("Respuesta no esperada:", response.data);
          this.items_contratos = [];
          this.snackbar = true;
        }
      });
    },

    listarContratoClienteTodos() {
      axios.get("api/ContratoCliente/ListarTodos").then((response) => {
        if (Array.isArray(response.data)) {
          this.items_contratostodos = response.data;
        } else {
          console.error("Respuesta no esperada:", response.data);
          this.items_contratostodos = [];
          this.snackbar = true;
        }
      });
    },

    descargarArchivoContrato(tipo) {
      if (tipo === "pdf" || tipo === "xls") {
        this.descargarContrato(tipo);
      }
      this.dialog_select_rendimiento_contrato = false;
    },

    descargarContrato(tipo) {
      const idEmpresa = this.$store.state.emp.id_empresa;
      if (!idEmpresa) {
        console.error("El id_empresa es undefined");
        return;
      }

      this.loading_facturas = true;

      const parametros = {
        id_empresa: idEmpresa,
        tipo_doc: tipo,
        server: "SERVER",
        folio: 0,
        num_contrato: this.contrato ? this.contrato.numero_contrato : null,
      };

      axios
        .post("api/Facturas/IngresoContrato", parametros)
        .then((response) => {
          if (tipo == "xls") {
            this.descargarArchivoExcel(
              this.generarBlob(response.data, "application/vnd.ms-excel"),
              "REPORTE_CONTRATOS.xls"
            );
          } else {
            this.base64_doc = "data:application/pdf;base64," + response.data;
            this.dialog_preview_report = true;
          }
        })
        .catch((error) => {
          console.error("STATUS:", error?.response?.status);
          console.error("DATA:", error?.response?.data);
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading_facturas = false;
        });
    },

    descargarArchivoClienteIngreso(tipo) {
      if (tipo === "pdf" || tipo === "xls") {
        this.descargarCliente(tipo);
      }
      this.dialog_select_rendimiento_cliente = false;
    },

    descargarCliente(tipo) {
      const idEmpresa = this.$store.state.emp.id_empresa;
      if (!idEmpresa) {
        console.error("El id_empresa es undefined");
        return;
      }

      this.loading_facturas = true;

      const parametros = {
        id_empresa: idEmpresa,
        tipo_doc: tipo,
        server: "SERVER",
        folio: 0,
        nombre_cliente: this.cliente ? this.cliente.nombre : null,
      };

      axios
        .post("api/Facturas/IngresoCliente", parametros)
        .then((response) => {
          if (tipo == "xls") {
            this.descargarArchivoExcel(
              this.generarBlob(response.data, "application/vnd.ms-excel"),
              "REPORTE_CLIENTES.xls"
            );
          } else {
            this.base64_doc = "data:application/pdf;base64," + response.data;
            this.dialog_preview_report = true;
          }
        })
        .catch((error) => {
          console.error("STATUS:", error?.response?.status);
          console.error("DATA:", error?.response?.data);
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading_facturas = false;
        });
    },

    descargarArchivoIngresos(tipo) {
      if (tipo === "pdf" || tipo === "xls") {
        this.descargarIngresos(tipo);
      }
      this.dialog_select_rendimiento_ingresos = false;
    },
    listarRendimientoIngresos() {
      this.items_rendimiento_ingresos = [];
      this.loading_rendimiento_ingresos = true;
      axios
        .get(
          "api/Facturas/RendimientoIngresos/" +
            this.$store.state.emp.id_empresa +
            "/" +
            this.fecha_rendimiento_ingresos
        )
        .then((response) => {
          //console.log(response.data);
          this.loading_rendimiento_ingresos = false;
          response.data.forEach((item) => {
            item.detallefactura.forEach((detalle) => {
              if (detalle.cod_servicio == "11") {
                this.items_rendimiento_ingresos.push({
                  "Fecha": this.formatDate(item.fecha),
                  "Numero control": item.numero_control.split("-").pop().replace(/^0+/, ""),
                  "Tipo documento": item.tipoDocFiscal.cod_doc_fiscal,
                  "Arrendatario": item.cliente.nombre,
                  "Deposito": "$ " + Number(item.saldo).toFixed(2),
                  "Desglose": "$ " + Number(detalle.total).toFixed(2),
                  "Arrendamiento": "$ " + Number(detalle.total).toFixed(2),
                  "Gasto admon": "",
                  "Venta directa": "",
                  "Subasta": "",
                  "Subasta incautada": "",
                  "Bases subastas": "",
                })
              }
              if (detalle.cod_servicio == "16") {
                this.items_rendimiento_ingresos.push({
                  "Fecha": this.formatDate(item.fecha),
                  "Numero control": item.numero_control.split("-").pop().replace(/^0+/, ""),
                  "Tipo documento": item.tipoDocFiscal.cod_doc_fiscal,
                  "Arrendatario": item.cliente.nombre,
                  "Desglose": "$ " + Number(detalle.total).toFixed(2),
                  "Arrendamiento": "",
                  "Deposito": "$ " + Number(item.saldo).toFixed(2),
                  "Gasto admon": "$ " + (Number(detalle.total) / 1.13).toFixed(2),
                  "Venta directa": "",
                  "Subasta": "",
                  "Subasta incautada": "",
                  "Bases subastas": "",
                })
              }
              if (detalle.cod_servicio == "25") {
                this.items_rendimiento_ingresos.push({
                  "Fecha": this.formatDate(item.fecha),
                  "Numero control": item.numero_control.split("-").pop().replace(/^0+/, ""),
                  "Tipo documento": item.tipoDocFiscal.cod_doc_fiscal,
                  "Arrendatario": item.cliente.nombre,
                  "Deposito": "$ " + Number(item.saldo).toFixed(2),
                  "Desglose": "$ " + Number(detalle.total).toFixed(2),
                  "Arrendamiento": "",
                  "Gasto admon": "",
                  "Venta directa": "$ " + Number(detalle.total).toFixed(2),
                  "Subasta": "",
                  "Subasta incautada": "",
                  "Bases subastas": "",
                })
              }
              if (detalle.cod_servicio == "17") {
                this.items_rendimiento_ingresos.push({
                  "Fecha": this.formatDate(item.fecha),
                  "Numero control": item.numero_control.split("-").pop().replace(/^0+/, ""),
                  "Tipo documento": item.tipoDocFiscal.cod_doc_fiscal,
                  "Arrendatario": item.cliente.nombre,
                  "Deposito": "$ " + Number(item.saldo).toFixed(2),
                  "Desglose": "$ " + Number(detalle.total).toFixed(2),
                  "Arrendamiento": "",
                  "Gasto admon": "",
                  "Venta directa": "",
                  "Subasta": "$ " + Number(detalle.total).toFixed(2),
                  "Subasta incautada": "",
                  "Bases subastas": "",
                })
              }
              if (detalle.cod_servicio == "15") {
                this.items_rendimiento_ingresos.push({
                  "Fecha": this.formatDate(item.fecha),
                  "Numero control": item.numero_control.split("-").pop().replace(/^0+/, ""),
                  "Tipo documento": item.tipoDocFiscal.cod_doc_fiscal,
                  "Arrendatario": item.cliente.nombre,
                  "Deposito": "$ " + Number(item.saldo).toFixed(2),
                  "Desglose": "$ " + Number(detalle.total).toFixed(2),
                  "Arrendamiento": "",
                  "Gasto admon": "",
                  "Venta directa": "",
                  "Subasta": "",
                  "Subasta incautada": "$ " + Number(detalle.total).toFixed(2),
                  "Bases subastas": "",
                })
              }
              if (detalle.cod_servicio == "14") {
                this.items_rendimiento_ingresos.push({
                  "Fecha": this.formatDate(item.fecha),
                  "Numero control": item.numero_control.split("-").pop().replace(/^0+/, ""),
                  "Tipo documento": item.tipoDocFiscal.cod_doc_fiscal,
                  "Arrendatario": item.cliente.nombre,
                  "Deposito": "$ " + Number(item.saldo).toFixed(2),
                  "Desglose": "$ " + Number(detalle.total).toFixed(2),
                  "Arrendamiento": "",
                  "Gasto admon": "",
                  "Venta directa": "",
                  "Subasta": "",
                  "Subasta incautada": "",
                  "Bases subastas": "$ " + Number(detalle.total).toFixed(2),
                })
              }
            })
          })
        });
    },
    descargarIngresos(tipo) {
      console.log("aqui");
      
      const idEmpresa = this.$store.state.emp.id_empresa;
      if (!idEmpresa) {
        console.error("El id_empresa es undefined");
        return;
      }

      this.loading_facturas = true;

      this.generarExcel(this.items_rendimiento_ingresos, "Rendimiento ingresos");

      /*const parametros = {
        id_empresa: idEmpresa,
        tipo_doc: tipo,
        server: process.env.VUE_APP_CRYSTAL_SERVER,
        folio: this.num_folio,
        mes: this.fecha_rendimiento_ingresos,
      };

      axios
        .post("api/Facturas/ReporteRendimientoIngresos", parametros)
        .then((response) => {
          if (tipo == "xls") {
            this.descargarArchivoExcel(
              this.generarBlob(response.data, "application/vnd.ms-excel"),
              "REPORTE_INGRESOS.xls"
            );
          } else {
            this.base64_doc = "data:application/pdf;base64," + response.data;
            this.dialog_preview_report = true;
          }
        })
        .catch((error) => {
          console.error("STATUS:", error?.response?.status);
          console.error("DATA:", error?.response?.data);
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading_facturas = false;
        });*/
    },

    descargarArchivoIngresosBancos(tipo) {
      if (tipo === "pdf" || tipo === "xls") {
        this.descargarIngresosBancos(tipo);
      }
      this.dialog_select_rendimiento_ingresos_bancos = false;
    },

    descargarIngresosBancos(tipo) {
      const idEmpresa = this.$store.state.emp.id_empresa;
      if (!idEmpresa) {
        console.error("El id_empresa es undefined");
        return;
      }

      this.loading_facturas = true;

      const parametros = {
        id_empresa: idEmpresa,
        tipo_doc: tipo,
        server: "SERVER",
        folio: 0,
        fecha_factura: this.fecha_factura === true,
        fecha_abono: this.fecha_abono === true,
        fecha_desde: this.fecha_desde || null,
        fecha_hasta: this.fecha_hasta || null,
      };

      axios
        .post("api/Facturas/ReporteRendimientoIngresos_Bancos", parametros)
        .then((response) => {
          if (tipo == "xls") {
            this.descargarArchivoExcel(
              this.generarBlob(response.data, "application/vnd.ms-excel"),
              "REPORTE_INGRESOS_BANCOS.xls"
            );
          } else {
            this.base64_doc = "data:application/pdf;base64," + response.data;
            this.dialog_preview_report = true;
          }
        })
        .catch((error) => {
          console.error("STATUS:", error?.response?.status);
          console.error("DATA:", error?.response?.data);
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading_facturas = false;
        });
    },

    descargarArchivoFlujo(tipo) {
      if (tipo === "pdf" || tipo === "xls") {
        this.descargarFlujos(tipo);
      }
      this.dialog_select_flujo = false;
    },

    descargarArchivoBienesExtiguidosCautelados(tipo) {
      if (tipo === "pdf" || tipo === "xls") {
        this.descargarBienesExtinguidosCautelados(tipo);
      }
      this.dialog_select_bienes_extiguido_cautelado = false;
    },

    descargarFlujos(tipo) {
      if (this.$store.state.emp.id_empresa) {
        this.loading_facturas = true;

        const parametros = {
          id_empresa: this.$store.state.emp.id_empresa,
          anio: parseInt(this.anio),
          tipo_doc: tipo, // "pdf" / "xls"
          server: process.env.VUE_APP_CRYSTAL_SERVER,
          folio: this.num_folio,
        };

        axios
          .post("api/Facturas/ReporteFlujoEfectivo", parametros)
          .then((response) => {
            if (tipo == "xls") {
              this.descargarArchivoExcel(
                this.generarBlob(response.data, "application/vnd.ms-excel"),
                "FLUJO EFECTIVO.xls"
              );
            } else {
              this.base64_doc = "data:application/pdf;base64," + response.data;
              this.dialog_preview_report = true;
            }
          })
          .catch(() => {
            this.snackbar_text =
              "No se pudo generar el reporte de Flujo de Efectivo";
            this.snackbar = true;
          })
          .finally(() => {
            this.loading_facturas = false;
          });
      } else {
        console.error("El id_empresa es undefined");
      }
    },

    descargarBienesExtinguidosCautelados(tipo) {
      if (this.$store.state.emp.id_empresa) {
        this.loading_facturas = true;

        const parametros = {
          id_empresa: this.$store.state.emp.id_empresa,
          anio: parseInt(this.anio),
          mes: this.mes,
          tipo_doc: tipo, // "pdf" / "xls"
          server: process.env.VUE_APP_CRYSTAL_SERVER,
          folio: this.num_folio,
        };

        axios
          .post("api/Facturas/ReporteBienesExtinguidoCautelado", parametros)
          .then((response) => {
            if (tipo == "xls") {
              this.descargarArchivoExcel(
                this.generarBlob(response.data, "application/vnd.ms-excel"),
                "BIENES EXTINGUIDO Y CAUTELADO.xls"
              );
            } else {
              this.base64_doc = "data:application/pdf;base64," + response.data;
              this.dialog_preview_report = true;
            }
          })
          .catch(() => {
            this.snackbar_text =
              "No se pudo generar el reporte de Bienes Extinguido y cautelado";
            this.snackbar = true;
          })
          .finally(() => {
            this.loading_facturas = false;
          });
      } else {
        console.error("El id_empresa es undefined");
      }
    },

    descargarArchivoCliente(tipo) {
      if (tipo === "pdf" || tipo === "xls") {
        this.descargarReporteGeneralClientesVarios(tipo);
      }
      this.dialog_select_cliente = false;
    },

    descargarReporteGeneralClientesVarios(tipo) {
      if (!this.$store.state.emp.id_empresa) return;

      this.loading_facturas = true;

      const CODIGO_CLIENTE_X = "06142811131041";

      axios
        .get(
          "api/Facturas/ListarAscendente/" + this.$store.state.emp.id_empresa
        )
        .then((response) => {
          if (!Array.isArray(response.data)) {
            this.snackbar_text = "Error en la respuesta del servidor";
            this.snackbar = true;
            return;
          }

          const anioSel = parseInt(this.anio);

          const data = response.data.filter((item) => {
            const fecha = new Date(item.fecha);
            const itemAnio = fecha.getFullYear();
            const itemMes = fecha.getMonth() + 1;

            const esCCFoFAC =
              item.id_tipo_doc_fiscal == "10" ||
              item.id_tipo_doc_fiscal == "11";

            const mismoAnio = itemAnio === anioSel;
            const mismoMes = !this.mes || itemMes === this.mes;

            const cliente = this.getClienteByIdLocal(item.id_cliente);
            const esClienteX =
              cliente &&
              String(cliente.codigo || "").trim() === CODIGO_CLIENTE_X;

            return esCCFoFAC && mismoAnio && mismoMes && esClienteX;
          });

          const id_facturas = data.map((x) => x.id_factura);

          if (id_facturas.length === 0) {
            this.snackbar_text =
              "No hay facturas (CCF/FAC) para Clientes Varios en el año seleccionado";
            this.snackbar = true;
            return;
          }

          const parametros = {
            id_facturas,
            tipo_doc: tipo,
            server: "SERVER",
            folio: 0,
            codigo_cliente: CODIGO_CLIENTE_X,
          };

          axios
            .post("api/Facturas/ReporteGeneralClientesVarios", parametros)
            .then((resp) => {
              if (tipo == "xls") {
                this.descargarArchivoExcel(
                  this.generarBlob(resp.data, "application/vnd.ms-excel"),
                  "REPORTE GENERAL CLIENTES VARIOS.xls"
                );
              } else {
                this.base64_doc = "data:application/pdf;base64," + resp.data;
                this.dialog_preview_report = true;
              }
            })
            .catch(() => {
              this.snackbar_text = "No se pudo generar el reporte";
              this.snackbar = true;
            });
        })
        .catch(() => {
          this.snackbar_text = "No se pudo obtener el listado de facturas";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading_facturas = false;
        });
    },

    descargarArchivoCXC(tipo) {
      if (tipo === "pdf" || tipo === "xls") {
        this.descargarCXC(tipo);
      }
      this.dialog_select_CXC = false;
    },

    descargarCXC(tipo) {
      const idEmpresa = this.$store.state.emp.id_empresa;
      if (!idEmpresa) {
        console.error("El id_empresa es undefined");
        return;
      }

      this.loading_facturas = true;

      const parametros = {
        id_empresa: idEmpresa,
        tipo_doc: tipo,
        server: "SERVER",
        folio: this.num_folio,
        fecha_contrato: this.fecha_contrato || null,
        fecha_vencimiento: this.fecha_vencimiento || null,
      };

      axios
        .post("api/Facturas/CXC_Segmentado", parametros)
        .then((response) => {
          if (tipo == "xls") {
            this.descargarArchivoExcel(
              this.generarBlob(response.data, "application/vnd.ms-excel"),
              "REPORTE_CXC.xls"
            );
          } else {
            this.base64_doc = "data:application/pdf;base64," + response.data;
            this.dialog_preview_report = true;
          }
        })
        .catch((error) => {
          console.error("STATUS:", error?.response?.status);
          console.error("DATA:", error?.response?.data);
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading_facturas = false;
        });
    },

    getProveedorByIdLocal(id_proveedor) {
      if (this.items_proveedores && this.items_proveedores[id_proveedor]) {
        return this.items_proveedores[id_proveedor];
      }
      return null;
    },

    getClienteByIdLocal(id_cliente) {
      if (this.items_clientes && this.items_clientes[id_cliente]) {
        return this.items_clientes[id_cliente];
      }
      return null;
    },

    listarFacturas() {
      this.loading_facturas = true;
      axios
        .get("api/Facturas/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items = response.data;
          this.loading_facturas = false;
        })
        .catch(() => {
          this.loading_facturas = false;
        });
    },

    listarSucursales() {
      axios
        .get("api/Sucursales/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_sucursales = response.data;
          this.sucursal = response.data[0].id_sucursal;
        });
    },

    listarMes() {
      axios.get("api/Mes/Listar").then((response) => {
        this.items_mes = response.data;
      });
    },

    // Listar todos los proveedores
    listarProveedores() {
      return axios
        .get("api/Proveedores/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_proveedores = response.data.reduce((map, proveedor) => {
            map[proveedor.id_proveedor] = proveedor;
            return map;
          }, {});
        })
        .catch((error) => {
          console.error("Error al listar los proveedores:", error);
          this.snackbar_text = "No se pudieron cargar los proveedores";
          this.snackbar = true;
        });
    },

    listarClientes() {
      const idEmpresa = this.$store.state.emp.id_empresa;
      return Promise.all([
        axios.get("api/Clientes/ListarTodos/" + idEmpresa),
        axios.get("api/ContratoCliente/ListarTodos"),
      ])
        .then(([resClientes, resContratos]) => {
          const idsConContrato = new Set(
            resContratos.data.map((c) => c.id_cliente)
          );
          this.items_clientes = resClientes.data.reduce((map, cliente) => {
            map[cliente.id_cliente] = cliente;
            return map;
          }, {});

          this.items_clientes_lista = resClientes.data.filter((c) =>
            idsConContrato.has(c.id_cliente)
          );
        })
        .catch((error) => {
          console.error("Error:", error);
          this.snackbar_text = "No se pudieron cargar los datos";
          this.snackbar = true;
        });
    },

    limpiarCliente() {
      this.cliente =
        this.items_clientes_lista.find(
          (c) => c.id_cliente === this.cliente.id_cliente
        ) || null;
      this.codigo_bien = null;
      this.contrato = null;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${day}/${month}/${year}`;
    },

    generarReporte() {
      axios
        .get("api/Factura/ReporteFAC")
        .then((response) => {
          this.items_fac = response.data;
        })
        .catch((error) => {
          console.error("Error al generar el reporte:", error);
        });
    },
    generarBlob(base64String, contentType) {
      const byteCharacters = atob(base64String);
      const byteArrays = [];

      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
      }

      const byteArray = new Uint8Array(byteArrays);
      return new Blob([byteArray], { type: contentType });
    },
    descargarArchivoExcel(blob, fileName) {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    generarExcel(obj, file_name) {
      let data = XLSX.utils.json_to_sheet(obj);
      const workbook = XLSX.utils.book_new();
      const filename = file_name;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
  },
};
</script>


<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

#myPDF {
  width: 100%;
  height: 100%;
}

.button-row {
  gap: 16px;
}

.button-custom {
  width: 200px;
  height: 200px;
  transition: transform 0.3s ease;
}

.button-custom:hover {
  transform: scale(1.1);
}

.button-image {
  width: 150px;
  height: 150px;
}

.button-label {
  margin-top: 8px;
  font-size: 18px;
  font-weight: bold;
  animation: fadeIn 0.5s ease;
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
}

.text-gradient {
  background: linear-gradient(90deg, #000000, #333333);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>